import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { cn } from '@costar-ui/cosmos';
import React__default, { useState, useCallback, useEffect } from 'react';
import { SingleRatingStar } from './single-rating-star.esm.js';
import { starRatingStyles } from '../star-rating-styles.esm.js';
import Slot from '../../layout/slot/slot.esm.js';

var _excluded = ["onClick", "disabled", "valueArray", "inactiveColor", "size", "containerClassname", "ratingClassname", "mode", "value", "testId"];
var defaultInactiveColor = '#FCFDFD'; //text-on-base-inverse
var defaultSize = 'std';
var hoverSelectColor = '#183969'; // text-action-selected
var StarRatingBase = function StarRatingBase(props) {
  var onClick = props.onClick,
    disabled = props.disabled,
    valueArray = props.valueArray,
    _props$inactiveColor = props.inactiveColor,
    inactiveColor = _props$inactiveColor === void 0 ? defaultInactiveColor : _props$inactiveColor,
    _props$size = props.size,
    size = _props$size === void 0 ? defaultSize : _props$size,
    containerClassname = props.containerClassname,
    ratingClassname = props.ratingClassname,
    mode = props.mode,
    value = props.value,
    testId = props.testId,
    rest = _objectWithoutProperties(props, _excluded);
  var _starRatingStyles = starRatingStyles({
      size: size
    }),
    container = _starRatingStyles.container,
    star = _starRatingStyles.star;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredIndex = _useState2[0],
    setHoveredIndex = _useState2[1];
  var _useState3 = useState(value || null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedIndex = _useState4[0],
    setSelectedIndex = _useState4[1];
  var handleMouseEnter = useCallback(function (i) {
    if (!disabled) {
      setHoveredIndex(i);
    }
  }, [disabled]);
  var handleMouseEnterWithIndex = function handleMouseEnterWithIndex(i) {
    return function () {
      return handleMouseEnter(i);
    };
  };
  var handleMouseLeave = useCallback(function () {
    if (!disabled) {
      setHoveredIndex(null);
    }
  }, [disabled]);
  var handleRatingClick = useCallback(function (i) {
    if (!disabled) {
      setSelectedIndex(i);
      setHoveredIndex(null); // Clear hover state after selection
      if (onClick) {
        onClick(i);
      }
    }
  }, [disabled, onClick]);
  var getHandleStarClick = useCallback(function (i) {
    return !disabled && onClick ? onClick(i) : mode === 'rating' ? function () {
      return handleRatingClick(i);
    } : undefined;
  }, [disabled, handleRatingClick, mode, onClick]);
  useEffect(function () {
    if (value !== undefined) {
      setSelectedIndex(value); // Update selected index if value prop changes
    }
  }, [value]);
  var effectiveSelectedIndex = mode === 'rating' && selectedIndex !== null ? selectedIndex : null;
  return /*#__PURE__*/React__default.createElement(Slot, _extends({
    className: cn(container(), containerClassname),
    testId: testId
  }, rest), valueArray.map(function (x, i) {
    var isHovered = hoveredIndex !== null && i <= hoveredIndex; // Highlight all stars up to hoveredIndex
    var isSelected = effectiveSelectedIndex !== null && i <= effectiveSelectedIndex; // Highlight all stars up to selectedIndex

    var modeRatingStarColors = isHovered ? hoverSelectColor : isSelected ? hoverSelectColor : inactiveColor;
    var handleStarClick = getHandleStarClick(i);
    return /*#__PURE__*/React__default.createElement(SingleRatingStar, {
      mode: mode,
      key: i,
      index: i,
      value: x,
      disabled: disabled,
      onClick: handleStarClick,
      strokeFill: mode === 'rating' && isHovered || isSelected ? hoverSelectColor : undefined,
      onMouseEnter: handleMouseEnterWithIndex(i),
      onMouseLeave: handleMouseLeave,
      inactiveColor: mode === 'rating' ? modeRatingStarColors : inactiveColor,
      classNames: cn(star(), ratingClassname)
    });
  }));
};

export { StarRatingBase };
//# sourceMappingURL=star-rating-base.esm.js.map
